if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');
			this.atcLabels = this.querySelectorAll('[data-js-product-add-to-cart-text], [data-js-sticky-atc-text]');
			this.qtyInput = this.querySelector('input[name="quantity"]');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			this._initVolumePricingListeners();
			this._initThemeGalleryLogic();
			this._initVariantLogic();
			this._initCartLogic();

		}

		disconnectedCallback(){
			if ( this._buyObserver ) {
				this._buyObserver.disconnect();
			}
		}

		_initVolumePricingListeners() {
			if ( ! window._volumePricingListenerAttached ) {
				document.addEventListener('volume-pricing:section-reloaded', event => {
					const sectionId = this.closest('.shopify-section')?.id.replace('shopify-section-', '');
					if ( event.detail.sectionId === sectionId ) {
						this.updateButtonPrice();
					}
				});
				window._volumePricingListenerAttached = true;
			}

			if ( this.qtyInput ) {
				this.qtyInput.addEventListener('input', () => this.updateButtonPrice());

				const qtyContainer = this.qtyInput.closest('quantity-input') || this.qtyInput.parentElement;
				qtyContainer?.addEventListener('click', () => {
					setTimeout(() => this.updateButtonPrice(), 10);
				});
			}

			this.addEventListener('click', e => {
				if ( e.target.closest('.mnml-volume-pricing__tier') ) {
					setTimeout(() => this.updateButtonPrice(), 20);
				}
			});
		}

		updateButtonPrice(variant = null) {
			window.requestAnimationFrame(() => {
				const currentVariant = variant || this.productVariants?.currentVariant;
				if ( ! currentVariant || ! this.atcLabels.length ) return;

				let priceToDisplay = currentVariant.price;
				let showSuffix = false;

				const pricingWidget = this.querySelector('.mnml-volume-pricing');
				const widgetVariantId = pricingWidget?.getAttribute('data-variant-id');
				const isWidgetActive = pricingWidget && ! pricingWidget.hasAttribute('hidden') && pricingWidget.offsetParent !== null;

				if ( isWidgetActive && Number(widgetVariantId) === currentVariant.id ) {
					const currentQty = parseInt(this.qtyInput?.value || 1);
					const tiers = Array.from(this.querySelectorAll('.mnml-volume-pricing__tier'));

					let activeTier = null;
					tiers.forEach(tier => {
						const tierQty = parseInt(tier.dataset.qty || 0);
						if ( currentQty >= tierQty ) activeTier = tier;
					});

					if ( activeTier && activeTier.dataset.pricePerItem ) {
						const tierPrice = parseFloat(activeTier.dataset.pricePerItem);

						if ( tierPrice < currentVariant.price ) {
							priceToDisplay = tierPrice;
							showSuffix = true;
						}
					}
				}

				this.atcLabels.forEach(label => {
					const baseText = label.innerHTML.includes(' • ') ? label.innerHTML.split(' • ')[0] : label.innerHTML;

					if ( currentVariant.available ) {
						const suffix = showSuffix ? ` <span class="volume-price-suffix">p/st.</span>` : '';
						label.innerHTML = `${baseText} • <small>${this._formatMoney(priceToDisplay)}${suffix}</small>`;
					} else {
						label.innerHTML = window.languages?.soldOut || 'Uitverkocht';
					}
				});
			});
		}

		_initThemeGalleryLogic() {
			if ( this.productSlider ) {

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click', e => {
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
						});
					});

					this.productSlider.addEventListener('change', e => {
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e => {
					const activeItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);

					if ( activeItem && activeItem.dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', activeItem.dataset.mediaId);
						}
						setTimeout(() => {
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				this.productSlider.addEventListener('ready', () => {
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, 'auto');
					}
				});

			}

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				if ( window.ProductModel ) {
					window.ProductModel.loadShopifyXR();
				}
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}
		}

		thumbnailNavigationHelper(index = 0) {
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
				if ( i == index ) {
					elm.classList.add('active');
					this.querySelector('.product-gallery__thumbnails-holder')?.scrollTo({
						left: elm.offsetLeft - 50,
						behavior: 'smooth'
					});
				} else {
					elm.classList.remove('active');
				}
			});
		}

		_initVariantLogic() {
			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');

			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({ target: this.productVariants });

				this.querySelectorAll('.product-variant__item--radio input').forEach(input => {
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color') ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					});
				});

			}
		}

		onVariantChangeHandler(e) {

			let variant = e.target.currentVariant;

			if ( variant ) {

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');

					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({ behavior: 'smooth', block: 'center' });
						}
					}
				}

				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm => {
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

				this.updateButtonPrice(variant);

			}

		}

		_initCartLogic() {
			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
				const productForm = this.querySelector('[data-js-product-form]');

				if ( addToCartButton ) {
					addToCartButton.addEventListener('keyup', e => {
						if ( e.keyCode == window.KEYCODES.RETURN || e.key === 'Enter' ) {
							addToCartEnter = true;
						}
					});
				}

				if ( productForm ) {
					productForm.addEventListener('add-to-cart', () => {
						document.getElementById('site-cart-sidebar')?.show();

						if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}

						if ( addToCartEnter ) {
							setTimeout(() => {
								document.querySelector('#site-cart-sidebar [data-js-close]')?.focus();
							}, 200);
						}
					});
				}

				if ( addToCartButton ) {
					const checkBuyButton = () => {
						if ( addToCartButton.classList.contains('disabled') ) {
							this.querySelector('product-form')?.classList.add('disable-buy-button');
						} else {
							this.querySelector('product-form')?.classList.remove('disable-buy-button');
						}
					};

					checkBuyButton();

					this._buyObserver = new MutationObserver(checkBuyButton);
					this._buyObserver.observe(addToCartButton, {
						attributes: true,
						childList: false,
						subtree: false
					});
				}

			}
		}

		_formatMoney(price) {
			const format = KROWN?.settings?.money_format || window.Shopify?.money_format || '€{{amount}}';

			try {
				if ( window.Shopify?.formatMoney ) {
					return window.Shopify.formatMoney(price, format);
				}

				const value = (price / 100).toFixed(2).replace('.', format.includes('€') ? ',' : '.');
				return format.replace(/\{\{\s*?\w*\s*?\}\}/, value);
			} catch (e) {
				return '€' + (price / 100).toFixed(2).replace('.', ',');
			}
		}

	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}